import {
  CommodityField,
  FloridaLoadDescriptionField,
  FloridaLoadIdentityField,
  FloridaPermitTypeField,
  LoadDescriptionField,
  LoadEndToEndCountField,
  LoadHeightField,
  LoadIndustryTypeField,
  LoadIsNewlyManufacturedField,
  LoadIsSingleItemField,
  LoadLengthField,
  LoadLoadingMethod,
  LoadMakeField,
  LoadModelField,
  LoadQuantityField,
  LoadSealedContainerChassisNumberField,
  LoadSealedContainerNumberField,
  LoadSerialNumberField,
  LoadSideBySideCountField,
  LoadStackCountField,
  LoadWeightField,
  LoadWidthField,
  LoadYearField,
} from '@src/permitField/LoadInformationFields';

export const loadinformationSectionFields = [
  LoadDescriptionField.fieldName,
  FloridaPermitTypeField.fieldName,
  FloridaLoadDescriptionField.fieldName,
  FloridaLoadIdentityField.fieldName,
  CommodityField.fieldName,
  LoadMakeField.fieldName,
  LoadModelField.fieldName,
  LoadSerialNumberField.fieldName,
  LoadSealedContainerNumberField.fieldName,
  LoadSealedContainerChassisNumberField.fieldName,
  LoadIndustryTypeField.fieldName,
  LoadQuantityField.fieldName,
  LoadYearField.fieldName,
  LoadSideBySideCountField.fieldName,
  LoadEndToEndCountField.fieldName,
  LoadStackCountField.fieldName,
  LoadLengthField.fieldName,
  LoadWidthField.fieldName,
  LoadHeightField.fieldName,
  LoadWeightField.fieldName,
  LoadLoadingMethod.fieldName,
  LoadIsSingleItemField.fieldName,
  LoadIsNewlyManufacturedField.fieldName,
] as const;
